import { Toast } from "vant";
export default {
  /**
   * 时间戳转换年月日
   */
  formattedDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return date.toLocaleDateString("zh-CN", options);
  },



  /**
   * 手机号中间加*号
   */
  maskedString(originalString) {
    return originalString.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
  },

  /**
   * 提示
   */
  showToast(message, type = "fail", duration = 1000) {
    if (type === "success") {
      Toast.success({
        duration: duration,
        message: message,
      });
    } else {
      Toast.fail({
        duration: duration,
        message: message,
      });
    }
  },

  forData(timestamp) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // 返回格式化后的日期
  },

  forDate1(timestamp) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let obj = {
      year: year,
      month: `${month}.${day}`,
    }
    return obj
  },


  editStyleToContent(content) {
    // 处理 <img> 标签
    content = content.replace(/<img([^>]*)>/g, (match, p1) => {
      if (p1.includes('style="')) {
        return match.replace(/style="([^"]*)"/, (styleMatch, styles) => {
          return `style="${styles}; margin: 0 auto;"`;
        });
      }

      return `<img${p1} style="margin: 0 auto;">`;
    });
    content = content.replace(/<span([^>]*)>/g, (match, p1) => {
      if (p1.includes('style="')) {
        return match.replace(/style="([^"]*)"/, (styleMatch, styles) => {
          return `style="${styles}; text-wrap: auto;"`;
        });
      }

      return `<span${p1} style="text-wrap: auto;">`;
    });

    return content;
  },

  addStyleToImg(content) {
    if (!content) return "";
    return content.replace(/<(img)([^>]*)>/g, (match, tag, p1) => {
      // 如果已经有style属性，直接修改它
      if (p1.includes('style="')) {
        return match.replace(/style="([^"]*)"/, (styleMatch, styles) => {
          return `style="${styles}; max-width: 100%"`;
        });
      } else {
        // 如果没有style属性，直接添加
        return `<${tag}${p1} style="max-width: 100%;">`;
      }
    });
  },

  addStyleToP(content) {
    if (!content) return "";
    return content.replace(/<(p)([^>]*)>/g, (match, tag, p1) => {
      // 如果已经有style属性且没有font-size，直接修改它
      if (p1.includes('style="') && !p1.includes('font-size:')) {
        return match.replace(/style="([^"]*)"/, (styleMatch, styles) => {
          return `style="${styles}; font-size: 17px;"`;
        });
      } else {
        // 如果没有style属性，直接添加
        return `<${tag}${p1} style="font-size: 17px;">`;
      }
    });
  },

  addStyleToP2(content) {
    if (!content) return "";
    return content.replace(/<(p)([^>]*)>/g, (match, tag, p1) => {
      // 如果已经有style属性且没有font-size，直接修改它
      if (p1.includes('style="') && !p1.includes('font-size:')) {
        return match.replace(/style="([^"]*)"/, (styleMatch, styles) => {
          return `style=" font-size: 14px;color: #1B1B1B;${styles};"`;
        });
      } else {
        // 如果没有style属性，直接添加
        return `<${tag}${p1} style="font-size: 14px;color: #1B1B1B;">`;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/base.js